<p-card styleClass="no-padding-card">
  <div class="flex flex-wrap" *ngIf="scheduleContext && hasSchedule; else noSchedule">
    <div class="schedule-label">
      <span>Driver Schedule</span>
      <p *ngIf="task?.taskSupplierSchedule?.lastUpdatedByType != null" class="font-normal">
        <span
          *ngIf="
            task?.taskSupplierSchedule?.lastUpdatedByType === DriverScheduleUpdateTypeEnum.Juno
          "
          >Automatically set by
        </span>
        <span
          *ngIf="
            task?.taskSupplierSchedule?.lastUpdatedByType !== DriverScheduleUpdateTypeEnum.Juno
          "
          >Manually updated by
        </span>

        <span class="font-bold">{{
          DriverScheduleUpdateTypeLabels[task?.taskSupplierSchedule?.lastUpdatedByType]
        }}</span>
        on
        <span class="font-bold">{{
          task?.taskSupplierSchedule?.lastUpdated | datex : 'ddd, Do MMM'
        }}</span>
        at
        <span class="font-bold">{{
          task?.taskSupplierSchedule?.lastUpdated | datex : 'HH:mm'
        }}</span>
      </p>
    </div>
    <div class="schedule-box flex flex-grow-1 flex-wrap">
      <div class="start-box time-box">
        <div class="date-line">{{ pickUp.scheduledTime | datex : 'ddd, Do MMM' }}</div>
        <div class="time-line">
          {{ pickUp.scheduledTime | datex : 'H:mma' }} -
          {{ pickUp.scheduledTimeLatest | datex : 'H:mma' }}
        </div>
        <div class="address-line">
          {{ task.pickupLocation.city }}
          {{ task.pickupLocation.postcode }}
        </div>
      </div>

      <div class="flex-grow-1 flex flex-wrap arrow-and-delivery-box">
        <div class="arrow-box flex-grow-1 flex align-items-center">
          <div style="position: relative; height: 27px; width: 100%; text-align: center">
            <div class="arrow-shaft"></div>
            <div class="arrow-head"><i class="fa fa-angle-right"></i></div>
            <div class="arrow-text">{{ task.estimateTimeHHmm }} hours</div>
            <div class="arrow-text">{{ task.distance | toMiles }} miles</div>
          </div>
        </div>

        <div class="end-box time-box">
          <div class="date-line">{{ dropOff.scheduledTime | datex : 'ddd, Do MMM' }}</div>
          <div class="time-line">
            {{ dropOff.scheduledTime | datex : 'H:mma' }} -
            {{ dropOff.scheduledTimeLatest | datex : 'H:mma' }}
          </div>
          <div class="address-line">
            {{ task.dropoffLocation.city }}
            {{ task.dropoffLocation.postcode }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noSchedule>
    <div class="p-3" *ngIf="scheduleContext">
      <div class="schedule-label">
        <span>Driver Schedule not set</span>
        <p class="font-normal">To set a schedule, click the Edit Task Schedule button below.</p>
      </div>
    </div>
  </ng-template>
</p-card>
